import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {FileItemType} from '../../Utils/PolicyUtils'
import FormatTimestamp from 'app/components/FormatTimestamp'
import OwnerDisplay from 'app/components/OwnerDisplay'
import { useAuth } from 'app/modules/auth'
import { useState } from 'react'
import UpgradePlan from 'app/components/UpgradePlan'

export const PolicyRow: React.FC<{
  policyData: FileItemType
  index: number
  isTrialPlan: boolean
  handleCheckboxChange: (id: string) => void
  handleOpenModal: (id: string) => void
  handleDownloadClick: (policyData: FileItemType, isTemplate: boolean) => void
  handleDeleteClick: (policyData: FileItemType) => void
  currentAuditContext?: any
}> = ({
  policyData,
  index,
  isTrialPlan,
  handleCheckboxChange,
  handleOpenModal,
  handleDownloadClick,
  handleDeleteClick,
  currentAuditContext,
}) => {
  const rowStyle =
    isTrialPlan && index > 5 ? {filter: 'blur(4px)', pointerEvents: 'none' as const} : {}
  const { currentUser } = useAuth();
  const [showModal, setShowModal] = useState(false)

  return (
    <>
    <tr className='border-bottom border-dotted' style={rowStyle}>
     <td style={{ paddingTop: isTrialPlan && index > 5 ? '25px' : '', paddingBottom: isTrialPlan && index > 5 ? '25px' : '' }}>
        <div className='form-check form-check-sm form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            value={policyData.id}
            checked={policyData.isChecked || false}
            onChange={() => handleCheckboxChange(policyData.id)}
          />
        </div>
      </td>
      <td>
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-50px me-2'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#5A5A5A'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-file-text'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M14 3v4a1 1 0 0 0 1 1h4' />
              <path d='M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z' />
              <path d='M9 9l1 0' />
              <path d='M9 13l6 0' />
              <path d='M9 17l6 0' />
            </svg>
          </div>
          <div className='d-flex justify-content-start flex-column'>
            <span
              className='text-dark fw-bold text-hover-primary mb-0 mt-1 fs-6'
              style={{cursor:"pointer"}}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                if (!isTrialPlan || index < 5) handleOpenModal(policyData.id)
              }}
            >
              {policyData.policy}
            </span>
            <span className='text-muted fw-semibold text-muted d-block fs-7'>
              {policyData.storage}
            </span>
          </div>
        </div>
      </td>
      <td>
        <div className='d-flex align-items-center mt-1'>
          {Array.isArray(policyData.frameworks) && policyData.frameworks.length > 0 ? (
            <>
              <span
                className='badge px-3 rounded-pill fs-7 me-1'
                style={{border: '2px solid #E1E1E1'}}
              >
                {policyData.frameworks[0].trim()}
              </span>
              {policyData.frameworks.length > 1 && (
                <OverlayTrigger
                  placement='right'
                  popperConfig={{
                    modifiers: [{name: 'offset', options: {offset: [0, 8]}}],
                  }}
                  overlay={
                    <Tooltip
                      id='tooltip-frameworks'
                      style={{whiteSpace: 'pre-line', textAlign: 'left'}}
                    >
                      <span
                        style={{fontSize: '12px', display: 'block', textAlign: 'left'}}
                        className='fw-semibold'
                      >
                        {policyData.frameworks
                          .slice(1)
                          .map((framework) => framework.trim())
                          .join('\n')}
                      </span>
                    </Tooltip>
                  }
                >
                  <button className='btn btn-icon btn-sm'>
                    <span className='badge px-3 rounded-pill' style={{border: '2px solid #E1E1E1'}}>
                      +{policyData.frameworks.length - 1}
                    </span>
                  </button>
                </OverlayTrigger>
              )}
            </>
          ) : (
            <span>--</span>
          )}
        </div>
      </td>
      <td>
        <div className='d-flex align-items-center'>
          <div className='clearfix bshadow0 pbs fw-semibold'>
            <span
              className={`badge fs-7 ${
                policyData?.status === 'Incomplete'
                  ? 'badge-danger'
                  : policyData?.status === 'Needs approval'
                  ? 'badge-warning'
                  : policyData?.status === 'Needs review'
                  ? 'badge-info'
                  : 'badge-primary'
              }`}
              style={{
                color:
                  policyData?.status === 'Incomplete'
                    ? '#EE3043'
                    : policyData?.status === 'Needs approval'
                    ? '#FFA800'
                    : policyData?.status === 'Needs review'
                    ? '#007bff'
                    : '#0E9F6E',
                background:
                  policyData?.status === 'Incomplete'
                    ? '#FFF5F8'
                    : policyData?.status === 'Needs approval'
                    ? '#FFF8DD'
                    : policyData?.status === 'Needs review'
                    ? '#E0F0FF'
                    : '#E8F8F4',
              }}
            >
              {policyData?.status}
            </span>
          </div>
        </div>
      </td>
      <td>
        <span className='fw-semibold d-block fs-6'>
          {policyData?.last_approved
            ? FormatTimestamp({timestamp: policyData?.last_approved})
            : '--'}
        </span>
      </td>
      <td>
        <span className='fw-semibold d-block fs-6'>
          {policyData?.review_date ? FormatTimestamp({timestamp: policyData?.review_date}) : '--'}
        </span>
      </td>
      <td>
        <div className='d-flex align-items-center'>
          {policyData.owner ? <OwnerDisplay owner={policyData.owner} uid={policyData.owner_uid} /> : <>--</>}
        </div>
      </td>
      <td className='text-end'>
        {(!isTrialPlan || index < 5) && (
          <div className='dropdown mx-2'>
            <button
              className='btn btn-secondary border-0 p-0 m-2'
              type='button'
              id='dropdownMenu2'
              data-bs-toggle='dropdown'
              aria-haspopup='true'
              aria-expanded='false'
            >
              <img src='/media/buttons/Options.svg' alt='Options' />
            </button>
            <ul className='dropdown-menu' aria-labelledby='dropdownMenu2' style={{zIndex: 1}}>
              <li>
                <button
                  className='dropdown-item  text-hover-primary'
                  type='button'
                  style={{color: '#262626'}}
                  onClick={() => handleOpenModal(policyData.id)}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-eye mx-1'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                    <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                  </svg>{' '}
                  View Details
                </button>
              </li>
              <li>
                <button
                   className={`dropdown-item ${
                    (currentUser?.role === 'Auditor' || !!currentAuditContext) ? 'text-gray-600' : ''
                  } `}
                  type='button'
                  style={{color: '#262626'}}
                  onClick={(e) =>
                    currentUser?.account_type === 'Trial'
                      ? setShowModal(true)
                      : handleDownloadClick(policyData, true)}
                  disabled={policyData.fileUrl.length === 0 || currentUser?.role === 'Auditor' || !!currentAuditContext}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-file-download mx-1 mb-1'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M14 3v4a1 1 0 0 0 1 1h4' />
                    <path d='M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z' />
                    <path d='M12 17v-6' />
                    <path d='M9.5 14.5l2.5 2.5l2.5 -2.5' />
                  </svg>{' '}
                  Download Template
                </button>
              </li>
              {policyData?.customfile &&
                policyData.customfile.length > 0 &&
                policyData.status === 'Approved' && (
                  <li>
                    <button
                      className='dropdown-item text-hover-primary'
                      type='button'
                      style={{color: '#262626'}}
                      onClick={() => handleDownloadClick(policyData, false)}
                      disabled={policyData?.customfile?.length === 0}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='18'
                        height='18'
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className='icon icon-tabler icons-tabler-outline icon-tabler-download mx-1 mb-1'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2' />
                        <path d='M7 11l5 5l5 -5' />
                        <path d='M12 4l0 12' />
                      </svg>{' '}
                      Download Evidence
                    </button>
                  </li>
                )}
              {policyData.author === 'Custom policy' && (
                <li>
                  <button
                    className='dropdown-item'
                    type='button'
                    style={{color: '#F15363'}}
                    onClick={() => handleDeleteClick(policyData)}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='#F15363'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-1 mb-1'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M4 7l16 0' />
                      <path d='M10 11l0 6' />
                      <path d='M14 11l0 6' />
                      <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                      <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                    </svg>{' '}
                    Remove
                  </button>
                </li>
              )}
            </ul>
          </div>
        )}
      </td>
    </tr>
     <UpgradePlan show={showModal} onClose={() => setShowModal(false)} />
     </>
  )
}
